import {RSDialog} from '../../libs/rsnotify/rsdialog';
import {ExtensionCategory} from '../../../functions/src/types';
import {Injectable} from '@angular/core';
import {DataService, ResolveCategory} from './data.service';
import {RSLoadingModalService} from '../../libs/rsloading/rsloading.service';
import {RSDialogService} from '../../libs/rsnotify/rsdialog.service';
import {
  PracticeChangeForm,
  PracticeChangeFormFertiliser,
  PracticeChangeFormPesticide, PracticeChangeFormSoil,
  PracticeChangeFormWater
} from './practice-change.types';
import {PracticeChangeWaterComponent} from '../views/practice-change-water/practice-change-water.component';
import {PracticeChangeFertiliserComponent} from '../views/practice-change-fertiliser/practice-change-fertiliser.component';
import {PracticeChangePesticideComponent} from '../views/practice-change-pesticide/practice-change-pesticide.component';
import {PracticeChangeSoilsComponent} from '../views/practice-change-soils/practice-change-soils.component';
import * as moment from 'moment/moment';

@Injectable({
  providedIn: 'root'
})
export class PracticeChangeService {

  public types: {[key: string]: PracticeChangeType } = { // Component
    B6VIFWNRAsIjBFzO2BDM: { // Fert
      name: 'Practice Change',
      component: PracticeChangeFertiliserComponent,
      fieldId: 'pcFertiliser',
      type: PracticeChangeFormFertiliser
    } as PracticeChangeType,
    NhnrvkTBHadd5hXhwYT0: { // Water
      name: 'Practice Change',
      component: PracticeChangeWaterComponent,
      fieldId: 'pcWater',
      type: PracticeChangeFormWater
    } as PracticeChangeType,
    MF7F0LZxLbJEqfCIXAx0: { // Pest
      name: 'Practice Change',
      component: PracticeChangePesticideComponent,
      fieldId: 'pcPesticide',
      type: PracticeChangeFormPesticide
    } as PracticeChangeType,
    '2XJUjJgqeHT8PR6vmm0e': { // Soil
      name: 'Practice Change',
      component: PracticeChangeSoilsComponent,
      fieldId: 'pcSoil',
      type: PracticeChangeFormSoil
    } as PracticeChangeType
  };

  constructor(
    private loadingService: RSLoadingModalService,
    private rsDialogService: RSDialogService,
    private resolveCategory: ResolveCategory,
  ) { }

  async addPracticeChange(categoryType: string, inputs: any): Promise<PracticeChangeForm> {
    return new Promise<PracticeChangeForm>((resolve, reject) => {
      console.log('addPracticeChange::: ', categoryType);
      const category = this.resolveCategory.transform(categoryType);
      const form = this.types[categoryType];
      if (!categoryType || !category || !form || !form.fieldId) {
        return;
      }

      console.log('addPracticeChange::: ', category.name);
      const dialogOptions = new RSDialog.Options(RSDialog.Type.PROMPT, true);
      dialogOptions.title = category.name + ' - ' + form.name;
      dialogOptions.cancelable = false;
      dialogOptions.closeButton = false;
      dialogOptions.size = RSDialog.Size.MEDIUM;
      dialogOptions.style = RSDialog.Style.SUCCESS;

      // Add our custom component;
      dialogOptions.component = form.component;

      const classInput = new form.type({});
      classInput.fromObject(inputs);
      // Use an old fashioned object to assign variable values to;
      const oValues: { category: ExtensionCategory, inputs: PracticeChangeForm } = {category, inputs: classInput};

      console.log('addPracticeChange::: values:: ', oValues);
      dialogOptions.values = oValues;

      this.rsDialogService.showDialog(dialogOptions).then(v => {
        console.log('addPracticeChange::: result:: ', v);
        if (v) {
          console.log('addPracticeChange::: values:: ', oValues.inputs);
          oValues.inputs.completed = moment().format('X');
          resolve(oValues.inputs);
        } else {
          reject(v);
        }
      }, e => {
        reject(e);
      });
    });
  }
}

export interface PracticeChangeType {
  name: string;
  component: any;
  fieldId: string;
  type: new(a) => PracticeChangeForm;
}

